import React from 'react'
import { Spinner as SpinnerCore } from 'react-bootstrap'
import type { SpinnerProps as SpinnerCoreProps } from 'react-bootstrap/Spinner'

export type SpinnerProps = SpinnerCoreProps

export const Spinner = (props: SpinnerProps) => {
  return <SpinnerCore as="span" {...props} />
}

export const SpinnerSmall = ({ size = 'sm', ...props }: SpinnerProps) => {
  return <SpinnerCore size={size} {...props} />
}
